import { BlogPostData } from './types';
import { post as topTTSToolsPost } from './blogPosts/top-10-free-text-to-speech-tools-2025';
import { post as voiceAccessibilityPost } from './blogPosts/voice-accessibility-content-creation-2025';
import { post as aiVoiceGenerationPost } from './blogPosts/ai-voice-generation-technology-2025';
import { post as bestTTSSoftwarePost } from './blogPosts/best-text-to-speech-software-2025';
import { post as accessibilityRevolutionPost } from './blogPosts/accessibility-revolution-text-to-speech';
import { post as createHumanLikeAiVoicesNoDownloadsPost } from './blogPosts/create-human-like-ai-voices-no-downloads';
import { post as ttsChangingContentCreationPost } from './blogPosts/text-to-speech-changing-content-creation';
import { post as turnBlogPostsIntoPodcastsPost } from './blogPosts/turn-blog-posts-into-podcasts';
import { post as textToSpeechForElearningPost } from './blogPosts/text-to-speech-for-elearning';
import { post as evolutionTextToSpeechPost } from './blogPosts/evolution-text-to-speech-technology';
import { post as aiVoiceMarketingPost } from './blogPosts/ai-voice-generation-marketing-campaigns';
import { post as futureAudiobooksPost } from './blogPosts/future-audiobooks-ai-text-to-speech';
import { post as ttsGamingNpcDialoguePost } from './blogPosts/text-to-speech-gaming-npc-dialogue';

/**
 * Collection of all blog posts
 * Each post is imported from its own file in the blogPosts directory
 */
export const blogPostsData: BlogPostData[] = [
  topTTSToolsPost,
  voiceAccessibilityPost,
  aiVoiceGenerationPost,
  bestTTSSoftwarePost,
  accessibilityRevolutionPost,
  createHumanLikeAiVoicesNoDownloadsPost,
  ttsChangingContentCreationPost,
  turnBlogPostsIntoPodcastsPost,
  textToSpeechForElearningPost,
  evolutionTextToSpeechPost,
  aiVoiceMarketingPost,
  futureAudiobooksPost,
  ttsGamingNpcDialoguePost
  // Add new blog posts here as they are created
];

/**
 * Get a blog post by its slug
 * @param slug The slug of the blog post to find
 * @returns The blog post with the matching slug, or undefined if not found
 */
export const getBlogPostBySlug = (slug: string): BlogPostData | undefined => {
  return blogPostsData.find(post => post.slug === slug);
};

/**
 * Get related blog posts for a given post
 * @param post The blog post to find related posts for
 * @returns Array of related blog posts
 */
export const getRelatedPosts = (post: BlogPostData): BlogPostData[] => {
  if (!post.relatedPosts || post.relatedPosts.length === 0) {
    return [];
  }
  
  return blogPostsData.filter(p => post.relatedPosts?.includes(p.slug));
};

/**
 * Get blog posts by tag
 * @param tag The tag to filter by
 * @returns Array of blog posts with the matching tag
 */
export const getBlogPostsByTag = (tag: string): BlogPostData[] => {
  return blogPostsData.filter(post => post.tags.includes(tag));
};
